<template>
  <div class="userindex">
    <heads></heads>
    <banners :pic="'pic3'"></banners>
    <div class="container">
      <div class="textnav">
        <span
          v-for="(item,index) in navArray"
          :key="index"
          :class="nav==index?'nac-active':''"
          @click="getNav(index)"
        >{{item}}</span>
      </div>
    </div>
    <transition name="fade">
      <userInfo v-if="nav==0" />
    </transition>
    <transition name="fade">
      <activityOrder v-if="nav==1" />
    </transition>
    <transition name="fade">
      <integral v-if="nav==2" />
    </transition>
    <transition name="fade">
      <menberInfo v-if="nav==3" />
    </transition>
    <transition name="fade">
      <tourist v-if="nav==4" />
    </transition>
    <transition name="fade">
      <distributionCenter v-if="nav==5" />
    </transition>
    <transition name="fade">
      <wallet v-if="nav==6" />
    </transition>
    <transition name="fade">
      <distributionDetail v-if="nav==8" />
    </transition>
    <homeFoots></homeFoots>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";
import tourist from "@/components/userview/tourist.vue";
import distributionCenter from "@/components/userview/distributionCenter.vue"; //
import distributionDetail from "@/components/userview/distributionDetail.vue";
import menberInfo from "@/components/userview/menberInfo.vue";
import activityOrder from "@/components/userview/activityOrder.vue";
import userInfo from "@/components/userview/userInfo.vue";
import integral from "@/components/userview/integral.vue";
import wallet from "@/components/userview/wallet.vue";
import axios from "axios";
export default {
  name: "userindex",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      navArray: [
        "个人信息",
        "活动订单",
        "积分明细",
        "会员信息",
        "常用游客",
        "分销中心",
        "钱包"
      ]
    };
  },
  components: {
    heads,
    homeFoots,
    tourist,
    distributionCenter,
    distributionDetail,
    banners,
    menberInfo,
    activityOrder,
    userInfo,
    integral,
    wallet
  },
  computed: {
    nav() {
      return this.$route.params.id;
    },
    id() {
      return this.$route.query.id;
    }
  },
  methods: {
    getNav(index) {
      this.$router.push({ path: `/userindex/${index}` });
    },
    handleCurrentChange(val) {},
    handleSizeChange(val) {
      console.log("当前页:" + val);
    }
  },
  mounted() {},
  created() {}
};
</script>

<style scoped>
.activityIndex {
  width: 100%;
  height: 100%;

  /* text-align: left; */
}
.container {
  text-align: left;
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
}
.textnav {
  display: flex;
  width: 100%;
  justify-content: space-around;
  height: 40px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
  margin-top: 20px;
  padding: 0 240px;
  box-sizing: border-box;
}
.textnav > span {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}
.nac-active {
  color: #007741;
  font-weight: bold;
  border-bottom: 2px solid #007741;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/userview/userindex.vue